export const queryKeys = {
  user: {
    me: ['user', 'me'] as const,
  },
  vehicles: {
    mine: ['vehicles', 'mine'] as const,
    detail: (id: string) => ['vehicles', 'detail', id] as const,
  },
  driverSessions: {
    me: ['driver-sessions', 'me'] as const,
  },
  organizations: {
    assignable: (orgId: string) => ['organizations', orgId, 'assignable'] as const,
    invitations: (orgId: string) => ['organizations', orgId, 'invitations'] as const,
    roles: (orgId: string) => ['organizations', orgId, 'roles'] as const,
    drivers: (orgId: string) => ['organizations', orgId, 'drivers'] as const,
    members: (orgId: string) => ['organizations', orgId, 'members'] as const,
  },
  drivers: {
    me: ['drivers', 'me'] as const,
    licenceStatus: (orgId: string) => ['drivers', 'licence-status', orgId] as const,
    orgLicenceStatus: (orgId: string, userId: string) =>
      ['drivers', 'org-licence-status', orgId, userId] as const,
  },
  orders: {
    list: (filters?: Record<string, unknown>) => ['orders', 'list', filters] as const,
    detail: (id: string) => ['orders', 'detail', id] as const,
    activeOffer: ['orders', 'active-offer'] as const,
    assigned: (filters?: Record<string, unknown>) => ['orders', 'assigned', filters] as const,
  },
  admin: {
    users: ['admin', 'users'] as const,
    userDriverVerifications: (userId: string) =>
      ['admin', 'users', userId, 'driver-verifications'] as const,
    vehiclesPending: ['admin', 'vehicles', 'pending'] as const,
    driversPending: ['admin', 'drivers', 'pending'] as const,
  },
};
